import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { DealerType } from "../types/DealerType";
import { apiClient } from "src/utils/Api/apiClient";

interface dealerState {
        dealer: DealerType;
        dealerLoading: boolean;
        dealerError: string | null;
}

const initialState: dealerState = {
        dealer: {
                Id: 0,
                DealerId: "",
                Name: "",
                Enabled: false,
                EmailId: "",
                PhoneNumber: "",
                Notes: "",
                PrimaryContactEmail: "",
                PrimaryContactPhone: "",
                CreatedAt: "",
                ModifiedAt: "",
                Addresses: {
                        Address1: "",
                        Address2: "",
                        City: "",
                        State: "",
                        Country: "",
                        PostalCode: "",
                        AddressType: ""
                }
        },
        dealerLoading: false,
        dealerError: null
}

export const createDealer = createAsyncThunk(
        'dealer/createDealer',
        async (dealerData: any, { rejectWithValue }) => {
                try {
                        const response = await apiClient.post('dealer/createDealer', dealerData);
                        return response.data;
                } catch (dealerError: any) {
                        return rejectWithValue(dealerError.response.data || 'An error occured');
                }
        }
);

export const updateDealer = createAsyncThunk(
        'dealer/updateDealer',
        async (dealerData: any, { rejectWithValue }) => {
                try {
                        const response = await apiClient.post('dealer/updateDealer', dealerData).then();
                        return response.data;
                } catch (dealerError: any) {
                        return rejectWithValue(dealerError.response.data || 'An error occured');
                }
        }
);


export const getDealerById = createAsyncThunk(
        'dealer/getDealerById',
        async (dealerData: any, { rejectWithValue }) => {
                try {
                        const response = await apiClient.get(`dealer/getDealerByID/${dealerData}`);
                        return response.data;
                } catch (dealerError: any) {
                        return rejectWithValue(dealerError.message || 'An error occured');
                }
        }
);

const dealerSlice = createSlice({
        name: 'dealer',
        initialState,
        reducers: {
                dealerReset: () => initialState,
        },
        extraReducers: (builder) => {

                //get Dealers by Id from server
                builder.addCase(getDealerById.pending, (state) => {
                        state.dealerLoading = true;
                        state.dealerError = null;
                });
                builder.addCase(getDealerById.fulfilled, (state, action) => {
                        state.dealerLoading = false;
                        state.dealer = action.payload;
                });
                builder.addCase(getDealerById.rejected, (state, action) => {
                        state.dealerLoading = false;
                        state.dealerError = action.payload as string;
                });

                //add Dealers to server
                builder.addCase(createDealer.pending, (state) => {
                        state.dealerLoading = true;
                        state.dealerError = null;
                });
                builder.addCase(createDealer.fulfilled, (state, action) => {
                        state.dealerLoading = false;
                        state.dealer = action.payload;
                });
                builder.addCase(createDealer.rejected, (state, action) => {
                        state.dealerLoading = false;
                        state.dealerError = action.payload as string;
                });

                //add Dealers to server
                builder.addCase(updateDealer.pending, (state) => {
                        state.dealerLoading = true;
                        state.dealerError = null;
                });
                builder.addCase(updateDealer.fulfilled, (state, action) => {
                        state.dealerLoading = false;
                        state.dealer = action.payload;
                });
                builder.addCase(updateDealer.rejected, (state, action) => {
                        state.dealerLoading = false;
                        state.dealerError = action.payload as string;
                });

        }
});

export const { dealerReset } = dealerSlice.actions;
export default dealerSlice.reducer;
